import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Requisites = ({
  size,
  type,
  theme,
  className,
  dataTestId = "requisites-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.826 1.419c0-.737.597-1.334 1.333-1.334h6.477c.354 0 .693.14.943.39l3.61 3.61a1.333 1.333 0 0 1 .39.896v9.601c0 .737-.597 1.334-1.333 1.334H3.159a1.333 1.333 0 0 1-1.333-1.334V1.42Zm8.791.98 1.915 1.916h-1.248a.667.667 0 0 1-.667-.667V2.399ZM3.16 1.42h6.125v2.23a2 2 0 0 0 2 1.999h1.962v8.934H3.159V1.42Zm3.805 3.363-.521-1.056a.14.14 0 0 0-.25 0L5.67 4.782l-1.166.17a.14.14 0 0 0-.077.237l.843.823-.199 1.161c-.02.114.1.201.202.148l1.043-.548 1.043.548a.14.14 0 0 0 .202-.147l-.199-1.162.844-.823a.14.14 0 0 0-.077-.238l-1.166-.169ZM11.25 9.76h-6a.667.667 0 1 0 0 1.334h6a.667.667 0 0 0 0-1.334Zm-6 3.768a.667.667 0 0 1 0-1.333h3.468a.667.667 0 0 1 0 1.333H5.25Z"
    />
  </SVGIcon>
);
